import React, { useEffect, useRef, useState } from 'react'
import './landing-content.styles.scss'
import { Navigate, useParams, useNavigate } from 'react-router-dom'
import Header from '@/components/header/header.component'
import Footer from '@/components/footer/footer.component'
import { doc, getDoc } from "firebase/firestore";
import { db } from '@/utils/firebase.utils'
import { useSelector } from 'react-redux';
import eln_logo from '@/assets/elnlogo_wht.png';
import ipa_logo from '@/assets/logo-wht.png';
import eln_logo_white from '@/assets/elnlogo_wht.png';
import Header2025 from '../header-2025/header-2025.component'
import { ModalConfirm } from '../modal/modal.component'

const LandingContent = () => {

	const navigate = useNavigate();
	const screenSize = useSelector(state => state.listsData.screenSize);
	const currentUser = useSelector(state => state.userData.currentUser);
	const profile = useSelector(state => state.userData.userProfile)
	const dbData = useSelector(state => state.userData.dbData)
	const { id } = useParams()
	const [ noId, setNoId ] = useState(false)
	const [ siteType, setSiteType ] = useState(null);
	const [ confirmMessage, setConfirmMessage ] = useState(null);
	const approveRef = useRef();

	useEffect(() => {
		console.log(id)
		if (!id) {
			setNoId(true)
			console.log('checking for id')		
			return;
		}
	}, [])
	
	useEffect(() => {
		if (!id) {
			setNoId(true)
			return;
		}
		getEvalDoc(id);
	}, [id]);

	async function getEvalDoc(id) {
		const docRef = doc(db, 'evals', id);
		const docSnap = await getDoc(docRef);
		if (docSnap.exists()) {
			console.log(docSnap.data())
			let evaluation = docSnap.data();
			if (evaluation.source == 'bridge' || evaluation.source == 'mc') {
				setSiteType('eln')
			} else {
				setSiteType('ipa')
			}
		} else {
		  	// doc.data() will be undefined in this case
			setNoId(true);
		  	console.log("No such document!");
			setConfirmMessage('The evaluation ID you have entered is not valid. Please check the link and try again. If you continue to have issues, please contact support at support@edleadersnetwork.org.');
			approveRef.current = () => {
				navigate(`/`);
			};
		}
	}	

	useEffect(() => {
		if (id && siteType) {
			let href = window.location.origin
			// console.log(window.location)
			let encoded = encodeURIComponent(href  + `/sso/?token={token}&intendedurl=%2Feval%2F${id}`)
			// console.log(encoded)
			window.open(`https://eweb.ilprincipals.org/eweb/?Site=${siteType}&WebCode=LoginRequired&expires=yes&URL_success=${encoded}`, '_self')

		}
		
	}, [id, siteType])

	function goToEvals(e) {
        console.log(e)
		if (currentUser && profile && dbData) {
			navigate(`/home/${e}`)
            console.log(e)
		} else {
			let href = window.location.origin
			// console.log(window.location)
			let encoded = encodeURIComponent(href  + `/sso/?token={token}&intendedurl=%2Fhome%2F${e}`)
			// console.log(encoded)
			window.open(`https://eweb.ilprincipals.org/eweb/?Site=ipa&WebCode=LoginRequired&expires=yes&URL_success=${encoded}`, '_self')
		}
		
	}
	
	return (
		<div className={`landing-content ${screenSize}`}>
			<div className="index-header">
        		{
					(noId)
					? 
					<>
						<Header2025 />
						
						<div className={`uk-container main-content ${screenSize}`}>
							<div className='g-height-40'></div>
							<h3>Please make sure you are using the correct link to the evaluation.<br />Click one of the options below to see your completed evaluations.</h3>

							<div className='cards'>
								<button className='g-card source-card ipa'  onClick={() => goToEvals('ipa')}>
									<div className='source-card-icon-div'>
										<img src={ipa_logo} className='source-card-icon' />
									</div>
									<div className='source-card-text'>
										<h3>View My IPA Evaluations</h3>
									</div>
								</button>
								<button className='g-card source-card eln' onClick={() => goToEvals('eln')}>
									<div className='source-card-icon-div'>
										<img src={eln_logo_white} className='source-card-icon' />
									</div>
									<div className='source-card-text'>
										<h3>View My ELN Evaluations</h3>
									</div>
								</button>
							</div>
							<div className='g-height-40'></div>
						</div>
						
						<Footer />
					</>
					
					: ''
				}
		  	</div>
			<ModalConfirm
				show={confirmMessage}
				cancel={() => setConfirmMessage(null)}
				message={confirmMessage}
				onApprove={approveRef.current} />
		</div>
	)
}

export default LandingContent